<template>
	<section>
		<!--列表-->
		<el-table :data="orders" highlight-current-row v-loading="listLoading" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="cdSn" label="订单号" width="150">
			</el-table-column>
			<el-table-column prop="sum" label="金额" width="100">
			</el-table-column>
			<el-table-column prop="count" label="数量" width="100">
			</el-table-column>
			<el-table-column prop="payway" label="付款方式" width="88">
			</el-table-column>
			<el-table-column prop="createTime" label="下单时间" width="180">
			</el-table-column>
			<el-table-column label="操作" width="200">
				<template scope="scope">
					<el-button type="primary" size="small" @click="handleDeliveryOrder(scope.$index, scope.row)" icon="el-icon-search"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-form :inline="true" style="margin-top:10px">
			总计：&nbsp;&nbsp;
			<el-form-item label="微信">
				<span><b>{{weixin}}</b> &nbsp;RMB</span>
			</el-form-item>
			<el-form-item label="支付宝">
				<span><b>{{alipay}}</b> &nbsp;RMB</span>
			</el-form-item>
			<el-form-item label="现金">
				<span><b>{{cash}}</b> &nbsp;RMB</span>
			</el-form-item>
			<el-form-item label="POS">
				<span><b>{{pos}}</b> &nbsp;RMB</span>
			</el-form-item>
			<el-button type="warning" @click.native="handleCheck" :disabled="this.orders.size==0">盘点确认</el-button>
		</el-form>

		<!--订单详情界面-->
		<el-dialog title="订单详情" :visible.sync="deliveryOrderVisible" :close-on-click-modal="false">
			<el-table :data="orderGoods" highlight-current-row v-loading="orderGoodsLoading" style="width: 100%;" >
			    <el-table-column type="index" width="55">
				</el-table-column>
				<el-table-column prop="name" label="商品名称" width="150" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="brand" label="品牌" width="70">
				</el-table-column>
				<el-table-column prop="form" label="规格" width="250" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="unit" label="单位" width="70">
				</el-table-column>
				<el-table-column prop="count" label="数量" width="80">
				</el-table-column>
				<el-table-column prop="price" label="单价" width="100">
				</el-table-column>
			</el-table>

			<!-- 打印插件安装提示 -->
			<div id="footer"></div>

			<div slot="footer" class="dialog-header">
				<el-button type="warning" @click="handlePrint()">打印送货单</el-button>
				<el-button type="danger" @click.native="deliveryOrderVisible=false">取消</el-button>
			</div>
		</el-dialog>


	</section>
</template>

<script>
	import util from '../../common/js/util'
	import Cookies from 'js-cookie'
	import {getLodop} from '../../common/js/LodopFuncs'
	import { getOrderListCheck, getOrderDetail, addCheck} from '../../api/api';

	var LODOP
	export default {
		data() {
			return {
				//a4纸
				height:1089,
				pageSize:20,
				pages:0,

				orders: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],//列表选中列

				//送货单界面
				deliveryOrderVisible: false,//查看页面是否显示

				//查看页面
				orderGoodsVisible: false,//查看页面是否显示
				orderGoodsLoading: false,
				orderGoods: [],//物料列表

				//发货界面数据
				sendForm: {},

				editLoading: false,

				//微信
				weixin: 0,
				//现金
				cash: 0,
				//支付宝
				alipay: 0,
				//POS
				pos: 0

			}
		},
		methods: {
			//处理盘点
			handleCheck() {
				this.editLoading = true;
				let check={};
            	check.weixin = this.weixin;
            	check.alipay = this.alipay;
            	check.cash = this.cash;
            	check.pos = this.pos;
            	check.sum = this.weixin+this.alipay+this.cash+this.pos;
            	check.orders = this.orders;
				addCheck(check).then((res) => {
					this.editLoading = false;
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.getOrders();
					}
				});
			},
			//获取订单列表
			getOrders() {
				let para = {
				};
				this.listLoading = true;
				getOrderListCheck(para).then((res) => {
					this.listLoading = false
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
	                	this.orders = res.data.data.list;
	                	this.weixin=0;
	                	this.alipay=0;
	                	this.cash=0;
	                	this.pos=0;
	                	this.orders.forEach(d=>{
	                		if(d.payway=="微信"){
	                			this.weixin+=d.sum;
	                		}else if(d.payway=="支付宝"){
	                			this.alipay+=d.sum;
	                		}else if(d.payway=="现金"){
	                			this.cash+=d.sum;
	                		}else if(d.payway=="POS"){
	                			this.pos+=d.sum;
	                		}
	                	});
	                }
				});
			},
			//根据订单号获取商品列表
			getGoodsByOrderId(orderId) {
				let para = { 
					id: orderId 
				};
				this.orderGoodsLoading = true;
				getOrderDetail(para).then((res) => {
					this.orderGoodsLoading = false;
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.orderGoods = res.data.data
					}
				});
			},
			//查看送货单
			handleDeliveryOrder: function(index, row){
				this.getGoodsByOrderId(row.id)
				this.deliveryOrderVisible = true
				this.sendForm = Object.assign({}, row);
			},
			
		    //初始化送货单
		    initPrintData:function(){
		    	this.pages = Math.ceil(this.sels.length / this.pageSize);
		    	//规定纸张大小；使用A4纸
				LODOP.SET_PRINT_PAGESIZE(1,0,0,"A4");
				for(let currentPage=0; currentPage<this.pages; currentPage++){
					this.drawSendOrder(currentPage);
				}
		    },
		    //送货单分页
		    drawSendOrder:function(page){
		    	LODOP.NewPage();
	    		this.loadPrintTemplate(page);
		    },
		    //送货单模版
		    loadPrintTemplate:function(page){
		    	//背景
		    	LODOP.ADD_PRINT_SETUP_BKIMG("<img border='0' src='https://bapi.dxx2xxn.cn/img/template/template5.png' width='793px' height='1123px'>");
		    	LODOP.SET_SHOW_MODE("BKIMG_PRINT",1);

		    	//需求公司
		    	LODOP.ADD_PRINT_TEXT(125,146,550,25,this.sendForm.demander);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10.5);
				//供应商
				LODOP.ADD_PRINT_TEXT(153,130,305,25,this.sendForm.provider);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10.5);
				//订单编号
				LODOP.ADD_PRINT_TEXT(180,146,144,19,this.sendForm.cdSn==''?'提前送货':this.sendForm.cdSn);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10.5);
				
				//请购人
				LODOP.ADD_PRINT_TEXT(153,507,150,25,this.sendForm.buyer+this.sendForm.buyerPhone);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10.5);
				//采购类型
				LODOP.ADD_PRINT_TEXT(206,522,108,25,this.sendForm.type);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10.5);
				
				//--行内容
				let sum = 0;
				let restCount = this.sels.length - page*this.pageSize;
				for (let j = page*this.pageSize; j <  (restCount<this.pageSize?this.sels.length:this.pageSize*(page+1)); j++) {
					let i = j+1;
					let item = this.sels[j];
					//序号
					LODOP.ADD_PRINT_TEXT(233+28*i-560*page,73,50,20,i);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//编号
					LODOP.ADD_PRINT_TEXT(233+28*i-560*page,123,80,20,item.itemNumber);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//名称
					LODOP.ADD_PRINT_TEXT(233+28*i-560*page,204,175,20,item.name);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//单位
					LODOP.ADD_PRINT_TEXT(233+28*i-560*page,389,50,20,item.unit);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//数量
					LODOP.ADD_PRINT_TEXT(233+28*i-560*page,450,60,20,item.count);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//单价
					LODOP.ADD_PRINT_TEXT(233+28*i-560*page,518,65,20,util.formatNumber(item.price));
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//总金额
					LODOP.ADD_PRINT_TEXT(233+28*i-560*page,586,75,20,util.formatNumber(item.count*item.price));
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					sum += (item.count*item.price);
				}
				sum = util.formatNumber(sum);
				//总金额
				LODOP.ADD_PRINT_TEXT(820,582,80,20,sum);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(178,523,134,25,this.sendForm.qgSn);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10.5);
				LODOP.ADD_PRINT_TEXT(206,146,89,20,this.sendForm.area);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10.5);
		    },
		    handlePrint: function(){
		    	LODOP=getLodop();  
				this.initPrintData();
				LODOP.PREVIEW();//打印预览
		    },
		    handleDesign: function(){
		    	LODOP=getLodop();  
				this.initPrintData();
				LODOP.PRINT_DESIGN();//打印设计	
		    },
    		
		},
		mounted() {
			this.getOrders();
		}
	}

</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }

</style>